import ModelProxy from "../../model-proxy";
import DatetimeUtils from "../../../gd/utils/datetime-utils";
import ModelEntity from "../../model-entity";
import {EntityType} from "../../../gd/const/item";
import ExpenseCategory from "../expense-category/expense-category";
import ErrorProto from "../../../gd/validation/error";
import ErrorFieldRequired from "../../../gd/validation/error-field-required";
import ErrorFieldIncorrectValue from "../../../gd/validation/error-field-incorrect-value";
import ApiExpenses from "../../../gd/api/expenses";
import Task from "../../task/task";
import Attachment from "../../attachment/attachment";
import {ExpenseApprovalStatus, ExpenseReimbursementStatus} from "../@types";
import {ExpenseAccessControl} from "./access-control/access-control";

export default class Expense extends ModelEntity {

    private _amount           : number | null   // null when unit based
    private _units            : number | null
    public comments           : string
    public expenseCategoryId  : ID

    public expenseDate        : Moment
    public momentCreated      : Moment

    public projectId          : ID
    public userId             : ID
    public taskId?            : ID
    public task?              : Task



    //New fields
    public name               : string
    public approvalStatus     : ExpenseApprovalStatus
    public reimbursementStatus: ExpenseReimbursementStatus
    public attachments        : Attachment[]

    constructor(data:any, useProxy = true) {
        super(data?.id, EntityType.EXPENSE)

        this._amount              = data?.amount;
        this._units               = data?.units;
        this.comments             = data?.comments;
        this.expenseCategoryId    = data?.expenseCategoryId;

        this.expenseDate          = DatetimeUtils.dateToMoment(data?.expenseDate);
        this.momentCreated        = DatetimeUtils.dateToMoment(data?.momentCreated);

        this.projectId            = data?.projectId;
        this.userId               = data?.userId;
        this.taskId               = data?.taskId;
        this.task                 = data?.task ? data.task instanceof Task ? data.task : new Task(data.task) : undefined;

        //New fields
        this.name                 = data.name
        this.approvalStatus       = data.approvalStatus || ExpenseApprovalStatus.PENDING
        this.reimbursementStatus  = data.reimbursementStatus || ExpenseReimbursementStatus.NOT_REIMBURSABLE
        this.attachments          = data.attachments

        // Patch name - we won't need it in future
        // dont apply it for new models
        if (!this.name && this.id) {
            if (this.comments) {
                this.name = this.comments.substring(0,180)
            } else {
                this.name = this.expenseCategory.name
            }
        }

        return useProxy ? new Proxy(this, ModelProxy) : this;
    }

    get acl():ExpenseAccessControl {
        return new ExpenseAccessControl(this)
    }

    // we need this field for column project path
    get projectPath():ID {
        return this.projectId
    }

    get total() {
        if (this.isAmountBased) return this._amount || 0

        if (this.isUnitBased && this._units) {
            const pricePerUnit : number = this.expenseCategory.unitPrice as number || 1
            return this._units * pricePerUnit
        }

        console.error("#0293943  something wrong no data ?")
        return 0
    }

    get amount():number {
        return this.total
    }

    set amount(amount:number|null) {
        this._amount = amount
    }

    get units(): number | null {
        return this.isUnitBased ? this._units : null;
    }

    set units(value: number | null) {
        this._units = value;
    }

    get expenseCategory():ExpenseCategory {

        const category = gd.session.expenseCategories.get(this.expenseCategoryId)

        /*if (!category) {
            throw Error("#kdjhsid03 no ExpenseCategory found id ="+this.expenseCategoryId)
        }*/

        return category
    }

    get isUnitBased():boolean {
        const expenseCategory = gd.session.expenseCategories.get(this.expenseCategoryId)
        if (!expenseCategory) return false
        return expenseCategory.isUnitBased
    }

    get isAmountBased():boolean {

        if (!this.expenseCategory) {
            console.warn("#jdkd03 no category for expense in session ???")
            return false
        }

        return this.expenseCategory.isAmountBased
    }

    toJSON() {
        return {
            id                  : this.id,
            projectId           : this.projectId,
            taskId              : this.taskId,
            userId              : this.userId,
            expenseCategoryId   : this.expenseCategoryId,
            comments            : this.comments,
            amount              : this.isAmountBased ? this._amount : null,
            units               : this.isUnitBased ? this._units : null,
            expenseDate         : DatetimeUtils.momentToDate(this.expenseDate),

            name                : this.name,
            approvalStatus      : this.approvalStatus,
            reimbursementStatus : this.reimbursementStatus,
            attachments         : this.attachments
        }
    }

    save() {
        const params : any = {}

        this.updatedFields.forEach((fieldName) => {

            switch (fieldName) {
                case 'expenseDate':
                    params['expenseDate'] = DatetimeUtils.momentToDate(this.expenseDate)
                    break
                default:
                    // @ts-ignore
                    params[fieldName] = this[fieldName];
                    break
            }


        })

        return ApiExpenses.update(this.id, params);
    }

    validate():ErrorProto[] | null  {

        const errors : any[] = []

        if (!this.name) errors.push(new ErrorFieldRequired(gd.fields.expense.name))
        if (!this.projectId) errors.push(new ErrorFieldRequired(gd.fields.expense.projectId))
        if (!this.expenseCategoryId) errors.push(new ErrorFieldRequired(gd.fields.expense.expenseCategoryId))

        if (this.isAmountBased) {
            if (!this._amount) errors.push(new ErrorFieldRequired(gd.fields.expense.amount))
            if (!gd.fields.expense.amount.isValueValid(this._amount)) errors.push(new ErrorFieldIncorrectValue(gd.fields.expense.amount))
        }

        if (this.isUnitBased) {
            if (!this._units) errors.push(new ErrorFieldRequired(gd.fields.expense.units))
            if (!gd.fields.expense.units.isValueValid(this._units)) errors.push(new ErrorFieldIncorrectValue(gd.fields.expense.units))
        }

        if (!this.expenseDate) errors.push(new ErrorFieldRequired(gd.fields.expense.expenseDate))

        // gd.fields.expense.amount.isValueValid(this.amount)

        if (_.isEmpty(errors)) return null
        else return errors
    }
}
